var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      filter: "invert(1)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 1C34.6981 1 22.2482 13.4248 22.2482 28.6957C22.2482 39.5143 28.8776 52.8711 35.3569 63.8312C41.8279 74.7913 48.2989 83.2548 48.2989 83.2548L50 85.4601L51.7011 83.2548C51.7011 83.2548 58.1721 74.7913 64.6431 63.8312C71.1224 52.8711 77.7518 39.5143 77.7518 28.6957C77.7518 13.4248 65.3019 1 50 1ZM50 5.26087C62.992 5.26087 73.4823 15.73 73.4823 28.6957C73.4823 37.6751 67.3032 50.9487 60.974 61.6675C55.487 70.9465 51.3759 76.2892 50 78.1201C48.6241 76.2892 44.513 70.9465 39.026 61.6675C32.6968 50.9487 26.5177 37.6751 26.5177 28.6957C26.5177 15.73 37.008 5.26087 50 5.26087ZM50 18.0435C44.1294 18.0435 39.3262 22.837 39.3262 28.6957C39.3262 34.5543 44.1294 39.3478 50 39.3478C55.8706 39.3478 60.6738 34.5543 60.6738 28.6957C60.6738 22.837 55.8706 18.0435 50 18.0435ZM50 22.3043C53.5607 22.3043 56.4043 25.1422 56.4043 28.6957C56.4043 32.2492 53.5607 35.087 50 35.087C46.4393 35.087 43.5957 32.2492 43.5957 28.6957C43.5957 25.1422 46.4393 22.3043 50 22.3043ZM12.2081 64.913L0 99H100L87.7919 64.913H71.456C70.6221 66.3777 69.7882 67.8008 68.9543 69.1739H84.7899L93.9293 94.7391H6.07071L15.2101 69.1739H31.0457C30.2118 67.8008 29.3779 66.3777 28.544 64.913H12.2081Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/icon-map.c8bdc6ce196e3a72d809866cf4673ebb.svg";
export { ForwardRef as ReactComponent };